// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file model/dto_organization.proto (package com.diagnocat.model, syntax proto3)
/* eslint-disable */

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { OrganizationJobPosition } from "./dto_organization_job_position_pb.js";
import { OrganizationPermissions } from "./dto_organization_permissions_pb.js";
import { Created, Deleted, Revision } from "./dto_base_pb.js";
import { StudyType } from "./dto_study_pb.js";
import { ReportType } from "./dto_report_pb.js";

/**
 * @generated from enum com.diagnocat.model.DentalNotationFormat
 */
export const DentalNotationFormat = proto3.makeEnum(
  "com.diagnocat.model.DentalNotationFormat",
  [
    {no: 0, name: "DentalNotationFormatISO"},
    {no: 1, name: "DentalNotationFormatUniversal"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.OrganizationType
 */
export const OrganizationType = proto3.makeEnum(
  "com.diagnocat.model.OrganizationType",
  [
    {no: 0, name: "OrganizationType_InvalidValue"},
    {no: 1, name: "OrganizationType_Dental"},
    {no: 2, name: "OrganizationType_NonDental"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.FeatureFlag
 */
export const FeatureFlag = proto3.makeEnum(
  "com.diagnocat.model.FeatureFlag",
  [
    {no: 0, name: "FeatureFlag_InvalidValue"},
    {no: 1, name: "FeatureFlag_Show_BillingShop"},
    {no: 7, name: "FeatureFlag_Show_SegmentronConditionsButtons"},
    {no: 8, name: "FeatureFlag_Show_NotForCommercialUseBanner"},
    {no: 9, name: "FeatureFlag_Show_IOSReportButton"},
    {no: 10, name: "FeatureFlag_Show_OrthoStudioAddSecondaryCBCT"},
    {no: 11, name: "FeatureFlag_Show_DentalPhotosWidget"},
    {no: 12, name: "FeatureFlag_Show_CBCTExtendedConclusion"},
    {no: 51, name: "FeatureFlag_Enable_SegmentronSerialisation"},
    {no: 52, name: "FeatureFlag_Enable_ToothSuggestedTreatment"},
    {no: 54, name: "FeatureFlag_Enable_OrthoStudio"},
    {no: 56, name: "FeatureFlag_Enable_StorageFeature"},
    {no: 57, name: "FeatureFlag_Enable_FullHeadMPRs"},
    {no: 58, name: "FeatureFlag_Enable_DICOMToDCCTConversion"},
    {no: 59, name: "FeatureFlag_Enable_DICOMToDCCTConversionFallback"},
    {no: 60, name: "FeatureFlag_Enable_SegmentronAirwaysHeatmap"},
    {no: 65, name: "FeatureFlag_Enable_AgentChat"},
    {no: 67, name: "FeatureFlag_Enable_ConsultationTemplates"},
    {no: 68, name: "FeatureFlag_Enable_Analytics"},
    {no: 69, name: "FeatureFlag_Enable_Encounters"},
    {no: 70, name: "FeatureFlag_Enable_CommunityPublishing"},
    {no: 71, name: "FeatureFlag_Enable_Diagnocoins"},
    {no: 72, name: "FeatureFlag_Enable_ArchiveReports"},
    {no: 73, name: "FeatureFlag_Enable_ReferralProgram"},
    {no: 74, name: "FeatureFlag_Enable_MaskEditing"},
    {no: 75, name: "FeatureFlag_Enable_SegmentronROI"},
    {no: 76, name: "FeatureFlag_Enable_MFASettings"},
    {no: 61, name: "FeatureFlag_FDA_Annotator"},
    {no: 62, name: "FeatureFlag_FDA_Unaided"},
    {no: 63, name: "FeatureFlag_FDA_SegmentronViewerRestrictions"},
    {no: 64, name: "FeatureFlag_FDA_3DGPRestrictions"},
    {no: 66, name: "FeatureFlag_FDA_Version2"},
    {no: 101, name: "FeatureFlag_Hide_Probabilities"},
    {no: 102, name: "FeatureFlag_Hide_ConditionsMasks"},
    {no: 103, name: "FeatureFlag_Hide_PerioMasksAndSlices"},
    {no: 104, name: "FeatureFlag_Hide_CariesSigns"},
    {no: 105, name: "FeatureFlag_Hide_PBLRulesAndMeasurements"},
    {no: 106, name: "FeatureFlag_Hide_AnatomyMasks"},
    {no: 107, name: "FeatureFlag_Hide_AllCBCTMasks"},
    {no: 108, name: "FeatureFlag_Hide_NonDentalFindings"},
    {no: 151, name: "FeatureFlag_Forbid_UploadsFromWeb"},
    {no: 152, name: "FeatureFlag_Forbid_PatientEditing"},
    {no: 153, name: "FeatureFlag_Forbid_Sharing"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.FeatureFlagType
 */
export const FeatureFlagType = proto3.makeEnum(
  "com.diagnocat.model.FeatureFlagType",
  [
    {no: 0, name: "FeatureFlagType_InvalidValue"},
    {no: 1, name: "FeatureFlagType_Development"},
    {no: 2, name: "FeatureFlagType_Regulatory"},
    {no: 3, name: "FeatureFlagType_Settings"},
  ],
);

/**
 * @generated from message com.diagnocat.model.Organization
 */
export const Organization = proto3.makeMessageType(
  "com.diagnocat.model.Organization",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Type", kind: "enum", T: proto3.getEnumType(OrganizationType) },
    { no: 4, name: "PrintName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "LogoAssetID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "StampAssetID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "Contacts", kind: "message", T: OrganizationContacts },
    { no: 8, name: "Settings", kind: "message", T: OrganizationSettings },
    { no: 9, name: "AvailableJobPositions", kind: "enum", T: proto3.getEnumType(OrganizationJobPosition), repeated: true },
    { no: 15, name: "OwnerEmail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "FeatureFlags", kind: "message", T: OrganizationFeatureFlag, repeated: true },
    { no: 12, name: "Comment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "OnboardedByDistributor", kind: "message", T: OrganizationOnboardedByDistributor },
    { no: 14, name: "Distributor", kind: "message", T: Distributor },
    { no: 16, name: "DSOParent", kind: "message", T: OrganizationDSOParent },
    { no: 17, name: "IsDSO", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "Billing", kind: "message", T: OrganizationBilling },
    { no: 19, name: "MFARequiredForActor", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 21, name: "Tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10020, name: "YourPermissions", kind: "message", T: OrganizationPermissions },
    { no: 10030, name: "Created", kind: "message", T: Created },
    { no: 10040, name: "Revision", kind: "message", T: Revision },
    { no: 10050, name: "Deleted", kind: "message", T: Deleted },
  ],
);

/**
 * @generated from message com.diagnocat.model.OrganizationSettings
 */
export const OrganizationSettings = proto3.makeMessageType(
  "com.diagnocat.model.OrganizationSettings",
  () => [
    { no: 1, name: "DentalNotationFormat", kind: "enum", T: proto3.getEnumType(DentalNotationFormat) },
    { no: 2, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "MFARequireForAllMembers", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.OrganizationContacts
 */
export const OrganizationContacts = proto3.makeMessageType(
  "com.diagnocat.model.OrganizationContacts",
  () => [
    { no: 1, name: "Country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "City", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Phones", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "Emails", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "WebSite", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "ZipCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.OrganizationDefinedPersonalData
 */
export const OrganizationDefinedPersonalData = proto3.makeMessageType(
  "com.diagnocat.model.OrganizationDefinedPersonalData",
  () => [
    { no: 1, name: "FirstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "LastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.Distributor
 */
export const Distributor = proto3.makeMessageType(
  "com.diagnocat.model.Distributor",
  () => [
    { no: 1, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.OrganizationOnboardedByDistributor
 */
export const OrganizationOnboardedByDistributor = proto3.makeMessageType(
  "com.diagnocat.model.OrganizationOnboardedByDistributor",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.OrganizationDSOParent
 */
export const OrganizationDSOParent = proto3.makeMessageType(
  "com.diagnocat.model.OrganizationDSOParent",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.OrganizationBilling
 */
export const OrganizationBilling = proto3.makeMessageType(
  "com.diagnocat.model.OrganizationBilling",
  () => [
    { no: 1, name: "SubscriptionEndDate", kind: "message", T: Timestamp, opt: true },
    { no: 2, name: "IsSubscriptionActive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.OrganizationFeatureFlag
 */
export const OrganizationFeatureFlag = proto3.makeMessageType(
  "com.diagnocat.model.OrganizationFeatureFlag",
  () => [
    { no: 1, name: "Flag", kind: "enum", T: proto3.getEnumType(FeatureFlag) },
    { no: 2, name: "Value", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "ReadOnly", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "Type", kind: "enum", T: proto3.getEnumType(FeatureFlagType) },
  ],
);

/**
 * @generated from message com.diagnocat.model.OrganizationStorageSize
 */
export const OrganizationStorageSize = proto3.makeMessageType(
  "com.diagnocat.model.OrganizationStorageSize",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Total", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "Own", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "Patients", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "Studies", kind: "message", T: OrganizationStorageStudySize, repeated: true },
    { no: 5, name: "Reports", kind: "message", T: OrganizationStorageReportSize, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.OrganizationStorageStudySize
 */
export const OrganizationStorageStudySize = proto3.makeMessageType(
  "com.diagnocat.model.OrganizationStorageStudySize",
  () => [
    { no: 1, name: "Type", kind: "enum", T: proto3.getEnumType(StudyType) },
    { no: 2, name: "Size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.OrganizationStorageReportSize
 */
export const OrganizationStorageReportSize = proto3.makeMessageType(
  "com.diagnocat.model.OrganizationStorageReportSize",
  () => [
    { no: 1, name: "Type", kind: "enum", T: proto3.getEnumType(ReportType) },
    { no: 2, name: "Size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

